module.exports = __webpack_public_path__ + "img/hr-H-T-6-unload-connect-shadow.388dc45d.png";